import { useState } from "react"

export const Section3 = ()=>{
  const[selectedIdx, setSelectedIdx] = useState(null)
  const [catetories, setCategories] = useState(
    {
      name:"sports",
      category:[
        {
          name:"exchange",
          img:"https://9wicket.pro/images/casinoIcon/EXCHANGE.svg"
        },
        {
          name:"i sports",
          img:"https://9wicket.pro/images/casinoIcon/I-SPORTS.svg"
        }, 
        {
          name:"h book",
          img:"https://9wicket.pro/images/casinoIcon/HORSEBOOK.svg"
        }, 
        {
          name:"virtual",
          img:"https://9wicket.pro/images/casinoIcon/VIRTUAL.svg"
        }, 
      ]
    }
  )
  const icons = ["sports","casino","slot","table","fishing","arcade","lottery"]
  
  const iconss = [
    {
    name:"sports",
    category:[
      {
        name:"exchange",
        img:"https://9wicket.pro/images/casinoIcon/EXCHANGE.svg"
      },
      {
        name:"i sports",
        img:"https://9wicket.pro/images/casinoIcon/I-SPORTS.svg"
      }, 
      {
        name:"h book",
        img:"https://9wicket.pro/images/casinoIcon/HORSEBOOK.svg"
      }, 
      {
        name:"virtual",
        img:"https://9wicket.pro/images/casinoIcon/VIRTUAL.svg"
      }, 
    ]
  },
    {
    name:"casino",
    category:[
      {
        name:"evolution",
        img:"https://9wicket.pro/images/casinoIcon/Casino/EVOLUTION.webp"
      },
      {
        name:"sexy",
        img:"https://9wicket.pro/images/casinoIcon/Casino/SEXYBCRT.png"
      }, 
      {
        name:"pp",
        img:"https://9wicket.pro/images/casinoIcon/Casino/provider-awcmpp.png"
      }, 
      {
        name:"hotroad",
        img:"https://9wicket.pro/images/casinoIcon/Casino/HOTROAD.png"
      }, 
    ]
  },
    {
    name:"slot",
    category:[
      {
        name:"pg",
        img:"https://9wicket.pro/images/casinoIcon/Slot/PGSOFT.webp"
      },
      {
        name:"rt",
        img:"	https://9wicket.pro/images/casinoIcon/Slot/provider-awcmrt.png"
      }, 
      {
        name:"spade",
        img:"	https://9wicket.pro/images/casinoIcon/Slot/SPADE.png"
      }, 
      {
        name:"jili",
        img:"	https://9wicket.pro/images/casinoIcon/Slot/JILI.png"
      }, 
      {
        name:"pp",
        img:"https://9wicket.pro/images/casinoIcon/Slot/PGSOFT.webp"
      },
      {
        name:"fastspin",
        img:"https://9wicket.pro/images/casinoIcon/Slot/provider-awcmfastspin.png"
      }, 
      {
        name:"play8",
        img:"	https://9wicket.pro/images/casinoIcon/Slot/PLAY8.png"
      }, 
      {
        name:"netent",
        img:"https://9wicket.pro/images/casinoIcon/Table/provider-netent.png"
      }, 
      {
        name:"dragoonsoft",
        img:"https://9wicket.pro/images/casinoIcon/Slot/DRAGOONSOFT.png"
      },
      {
        name:"kingmaker",
        img:"	https://9wicket.pro/images/casinoIcon/Slot/KINGMAKER.png"
      }, 
      {
        name:"nlc",
        img:"	https://9wicket.pro/images/casinoIcon/Slot/NLC.png"
      }, 
      {
        name:"yl",
        img:"https://9wicket.pro/images/casinoIcon/Slot/YL.png"
      }, 
      {
        name:"superspade",
        img:"	https://9wicket.pro/images/casinoIcon/Slot/SUPERSPADE.webp"
      }, 
    ]
  },
    {
    name:"table",
    category:[
      {
        name:"jili",
        img:"	https://9wicket.pro/images/casinoIcon/Slot/JILI.png"
      }, 
      {
        name:"kingmaker",
        img:"	https://9wicket.pro/images/casinoIcon/Slot/KINGMAKER.png"
      }, 
      {
        name:"pg",
        img:"https://9wicket.pro/images/casinoIcon/Slot/PGSOFT.webp"
      },
      {
        name:"netent",
        img:"https://9wicket.pro/images/casinoIcon/Table/provider-netent.png"
      }, 
      {
        name:"rt",
        img:"	https://9wicket.pro/images/casinoIcon/Slot/provider-awcmrt.png"
      }, 
    ]
  },
    {
    name:"fishing",
    category:[
        {
        name:"jili",
        img:"	https://9wicket.pro/images/casinoIcon/Slot/JILI.png"
      }, 
      {
        name:"fastspin",
        img:"https://9wicket.pro/images/casinoIcon/Slot/provider-awcmfastspin.png"
      }, 
      {
        name:"spade",
        img:"	https://9wicket.pro/images/casinoIcon/Slot/SPADE.png"
      }, 
      {
        name:"superspade",
        img:"	https://9wicket.pro/images/casinoIcon/Slot/SUPERSPADE.webp"
      }, 
      {
        name:"yesbingo",
        img:"	https://9wicket.pro/images/casinoIcon/Fishing/YESBINGO.png"
      }, 
      {
        name:"yl",
        img:"https://9wicket.pro/images/casinoIcon/Slot/YL.png"
      },  
    ]
  },
    {
    name:"arcade",
    category:[
      {
        name:"pp",
        img:"https://9wicket.pro/images/casinoIcon/Casino/provider-awcmpp.png"
      },
      {
        name:"yl",
        img:"https://9wicket.pro/images/casinoIcon/Slot/YL.png"
      }, 
      {
        name:"spade",
        img:"	https://9wicket.pro/images/casinoIcon/Slot/SPADE.png"
      }, 
      {
        name:"spribe",
        img:"	https://9wicket.pro/images/casinoIcon/Egame/SPRIBE.png"
      }, 
    ]
  },
    {
    name:"lottery",
    category:[
      {
        name:"yesbingo",
        img:"	https://9wicket.pro/images/casinoIcon/Fishing/YESBINGO.png"
      },
    ]
  },
]


  
  return <section className=" mt-3 ">
    <div className=" flex text-white overflow-x-auto scroll-smooth  gap- 3 items-center"> 
   { iconss.map((icon,idx)=>
    <div key={idx} 
    onClick={()=>{
      setSelectedIdx(idx)
      setCategories({category:icon.category, name:icon.name})
      }} className={`flex-shrink-0  flex-col justify-center p-3 ${selectedIdx === idx?" bg-[#252525] ":""} `}>
      <div className=" rounded-full hover:scale-110">
       <img src={`/new_img/${icon.name}.png`} alt="" width={icon.name=="casino"?55:50} className=" rounded-full" />
      </div>
       <div>
         <p className=" font-custom text-[14.4078px] text-center capitalize text-white mt-2 ">
          {icon.name}  
          </p>        
       </div> 
    </div>
   )

   }
    </div>

    <div className="px-2 font-custom text-[11.4078px] md:text-[14.4078px] lg:text-[14.4078px] ">
      <div className=" flex gap-1 mt-2">
        <div className=" bg-gray-400 w-[4px] h-[20px] inline-block " ></div>
      <h3 className=" text-white font-bold capitalize">
        {catetories.name}
        </h3>
      </div>
      <div className=" grid grid-cols-4 gap-[1px] mt-2">
        {catetories.category.map((category)=><div className=" text-white w-full flex flex-col items-center justify-center bg-bg-3 py-3">
          <div>
            <img src={category.img} alt="" width={40} className="" />
          </div>
          <div> 
            <h3 className=" uppercase">{category.name}</h3>
          </div>
        </div>)}
        
      </div>
    </div>
  </section>
}